import type { MouseEventProps, UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { Box } from '@gik/ui/Box';
import { Image } from '@gik/ui/Image';
import React from 'react';

export type ThankYouCardProps = {
  variant: string;
} & UIComponent &
  MouseEventProps;

export function ThankYouCard({
  children,
  className,
  variant,
  ...otherProps
}: React.PropsWithChildren<ThankYouCardProps>): React.ReactElement {
  const bem = useBemCN('thank-you-card');

  return (
    <Box rounded="md" {...bem(null, [{ [`variant-${variant}`]: variant }], className)} {...otherProps}>
      <div {...bem('header')}>
        <Image src="/messaging/thank-you/thank you!.png" />
      </div>
      <div {...bem('main')}>{children}</div>
    </Box>
  );
}
